export const CONSULTING_CONTENT = {
  de: {
    pills: ["VR-Mandate", "Sparringspartner", "Executive Coach"],
    headline: "Erfahrung, die Unternehmen weiterbringt.",
    intro: [
      "Erfolgreiche Unternehmen brauchen mehr als gute Ideen. Sie brauchen Menschen, die strategisch denken, Herausforderungen früh erkennen und Entscheidungen mit Weitblick begleiten.",
      "Genau hier setze ich an.",
      "Seit über 35 Jahren begleite ich Unternehmen als Unternehmer, Verwaltungsrat, Geschäftsführer und Berater. Ich kenne die Realität von inhabergeführten KMU ebenso wie die Anforderungen von Wachstumsunternehmen und Organisationen im Wandel.",
      "Meine Stärke liegt darin, komplexe Situationen rasch zu erfassen, Chancen und Risiken objektiv zu beurteilen und gemeinsam mit den Verantwortlichen tragfähige Lösungen zu entwickeln – pragmatisch, unabhängig und mit einem klaren Blick auf den nachhaltigen Unternehmenserfolg.",
    ],
    offerTitle: "Mein Angebot",
    offers: [
      {
        title: "Verwaltungsratsmandate",
        intro: "Als aktiver Verwaltungsrat begleite ich Unternehmen mit strategischem Weitblick und unternehmerischer Erfahrung. Dabei unterstütze ich insbesondere in den Bereichen:",
        points: [
          "Unternehmensstrategie und Zukunftsausrichtung",
          "Digitalisierung und Geschäftsmodellentwicklung",
          "Unternehmenswachstum und Skalierung",
          "Nachfolge- und Übergabeprozesse",
          "Organisationsentwicklung",
          "E-Commerce und digitale Geschäftsmodelle",
          "Marketing- und Vertriebsstrategien",
          "Risikobeurteilung und Governance",
          "Sparring für Eigentümer und Geschäftsleitung",
        ],
        note: "Ich verstehe den Verwaltungsrat nicht als Kontrollorgan allein, sondern als aktiven Sparringspartner mit unternehmerischer Verantwortung.",
      },
      {
        title: "Executive Coaching",
        intro: "Führung bedeutet heute, täglich Entscheidungen unter Unsicherheit zu treffen. Als persönlicher Coach begleite ich Unternehmerinnen, Unternehmer, CEOs, Verwaltungsräte und Führungskräfte bei wichtigen strategischen und persönlichen Fragestellungen. Typische Themen sind:",
        points: [
          "Strategische Entscheidungen",
          "Unternehmensentwicklung",
          "Führung und Leadership",
          "Persönliche Standortbestimmung",
          "Unternehmensnachfolge",
          "Veränderungsprozesse",
          "Krisenmanagement",
          "Persönliche Wirksamkeit als Führungspersönlichkeit",
        ],
        note: "Mein Coaching ist kein Standardprogramm. Es basiert auf Erfahrung, ehrlichem Dialog und dem gemeinsamen Ziel, nachhaltige Lösungen zu entwickeln.",
      },
    ],
    backgroundTitle: "Mein Hintergrund",
    backgroundText: [
      "Meine berufliche Laufbahn verbindet Unternehmertum mit operativer Führungsverantwortung. Ich durfte Unternehmen in den Bereichen Industrie, Handel, E-Commerce und Digitalisierung aufbauen und weiterentwickeln. Dabei habe ich zahlreiche Transformationsprojekte begleitet, Wachstumsstrategien umgesetzt und Unternehmen durch anspruchsvolle Veränderungsprozesse geführt.",
      "Diese Erfahrungen bringe ich heute als Verwaltungsrat, Berater und Coach in neue Mandate ein.",
    ],
    approachTitle: "Meine Arbeitsweise",
    approachIntro: "Ich arbeite unabhängig, diskret und auf Augenhöhe. Meine Kunden schätzen insbesondere:",
    approachPoints: [
      "unternehmerisches Denken statt theoretischer Konzepte",
      "objektive und ehrliche Einschätzungen",
      "schnelle Analyse komplexer Situationen",
      "pragmatische und umsetzbare Lösungen",
      "langfristige Zusammenarbeit auf Vertrauensbasis",
    ],
    audienceTitle: "Für wen ich tätig bin",
    audienceIntro: "Ich begleite vor allem:",
    audience: [
      "KMU",
      "Familienunternehmen",
      "Unternehmerinnen und Unternehmer",
      "Verwaltungsräte",
      "Geschäftsleitungen",
      "Unternehmen in Wachstums- oder Veränderungsphasen",
      "Nachfolge- und Übergabesituationen",
      "Start-ups mit Skalierungsambitionen",
    ],
    ctaTitle: "Lassen Sie uns ins Gespräch kommen",
    ctaText: [
      "Ob als Verwaltungsrat, strategischer Sparringspartner oder Executive Coach – ich begleite Sie mit unternehmerischer Erfahrung, strategischem Weitblick und dem klaren Ziel, Ihr Unternehmen nachhaltig weiterzuentwickeln.",
      "Ich freue mich darauf, Sie und Ihr Unternehmen kennenzulernen.",
    ],
    profile: {
      role: "Unternehmer · Verwaltungsrat · Executive Coach",
      stats: [
        "Über 35 Jahre Führungs- und Unternehmererfahrung",
        "Unternehmer, Verwaltungsrat und Executive Coach",
        "Erfahrung in Industrie, Handel, E-Commerce und Digitalisierung",
        "Spezialist für Strategie, Wachstum und Transformation",
        "Sparringspartner für Eigentümer, Verwaltungsräte und Geschäftsleitungen",
      ],
    },
    markipilot: {
      overline: "Digitales Wachstum",
      title: "marKIpilot — KI-gestütztes App-Marketing",
      intro: "Als Gründer von marKIpilot – der führenden KI-gestützten App-Marketing-Plattform der Schweiz – verbinde ich künstliche Intelligenz mit datengetriebenem Performance-Marketing. Ein eigenes MYSYMP-Produkt, das messbares App-Wachstum liefert.",
      services: [
        { t: "Pay-per-Install", d: "Sie zahlen nur für verifizierte Downloads – volle Kostentransparenz, null Risiko." },
        { t: "22 KI-Agenten", d: "Spezialisten für Content, Social, ASO, Creative und UX – inklusive Custom Agent Builder." },
        { t: "Performance Media", d: "Kampagnen-Dominanz auf Apple Search Ads, Google, Meta und TikTok mit KI-Optimierung." },
        { t: "Creative Factory", d: "KI-generierte Creatives, Playable Ads und laufendes A/B-Testing für maximale Hook-Rate." },
        { t: "Tech & Attribution", d: "Full-Stack MMP-Integration (AppsFlyer/Adjust), SKAN 4.0 und Deep-Link-Architektur." },
        { t: "KI-Analyse-Tools", d: "Content-Scorer, Creative Analyzer (Vision AI) und AI-Visibility-Check für ChatGPT, Perplexity & Gemini." },
      ],
      stats: [
        { v: "22", l: "KI-Agenten" },
      ],
      cta: "marKIpilot entdecken",
      url: "https://markipilot.com",
    },
  },
  en: {
    pills: ["Board mandates", "Sparring partner", "Executive coach"],
    headline: "Experience that moves companies forward.",
    intro: [
      "Successful companies need more than good ideas. They need people who think strategically, recognise challenges early and guide decisions with foresight.",
      "This is exactly where I come in.",
      "For over 35 years I have supported companies as an entrepreneur, board member, managing director and advisor. I know the reality of owner-managed SMEs as well as the demands of growth companies and organisations in transition.",
      "My strength lies in grasping complex situations quickly, assessing opportunities and risks objectively and developing viable solutions together with those responsible – pragmatic, independent and with a clear focus on sustainable business success.",
    ],
    offerTitle: "What I offer",
    offers: [
      {
        title: "Board mandates",
        intro: "As an active board member I support companies with strategic foresight and entrepreneurial experience. I provide particular support in the following areas:",
        points: [
          "Corporate strategy and future orientation",
          "Digitalisation and business model development",
          "Corporate growth and scaling",
          "Succession and handover processes",
          "Organisational development",
          "E-commerce and digital business models",
          "Marketing and sales strategies",
          "Risk assessment and governance",
          "Sparring for owners and management",
        ],
        note: "I see the board not merely as a supervisory body, but as an active sparring partner with entrepreneurial responsibility.",
      },
      {
        title: "Executive coaching",
        intro: "Leadership today means making decisions under uncertainty every day. As a personal coach I support entrepreneurs, CEOs, board members and executives on important strategic and personal questions. Typical topics are:",
        points: [
          "Strategic decisions",
          "Corporate development",
          "Leadership",
          "Personal positioning",
          "Business succession",
          "Change processes",
          "Crisis management",
          "Personal effectiveness as a leader",
        ],
        note: "My coaching is not a standard programme. It is based on experience, honest dialogue and the shared goal of developing sustainable solutions.",
      },
    ],
    backgroundTitle: "My background",
    backgroundText: [
      "My career combines entrepreneurship with operational leadership responsibility. I have had the privilege of building and developing companies in industry, trade, e-commerce and digitalisation. I have accompanied numerous transformation projects, implemented growth strategies and led companies through demanding change processes.",
      "Today I bring this experience into new mandates as a board member, advisor and coach.",
    ],
    approachTitle: "My way of working",
    approachIntro: "I work independently, discreetly and at eye level. My clients particularly appreciate:",
    approachPoints: [
      "entrepreneurial thinking instead of theoretical concepts",
      "objective and honest assessments",
      "rapid analysis of complex situations",
      "pragmatic and actionable solutions",
      "long-term collaboration based on trust",
    ],
    audienceTitle: "Who I work for",
    audienceIntro: "I primarily support:",
    audience: [
      "SMEs",
      "Family businesses",
      "Entrepreneurs",
      "Boards of directors",
      "Executive management",
      "Companies in growth or transition phases",
      "Succession and handover situations",
      "Start-ups with scaling ambitions",
    ],
    ctaTitle: "Let's start a conversation",
    ctaText: [
      "Whether as a board member, strategic sparring partner or executive coach – I support you with entrepreneurial experience, strategic foresight and the clear goal of sustainably developing your company.",
      "I look forward to getting to know you and your company.",
    ],
    profile: {
      role: "Entrepreneur · Board member · Executive coach",
      stats: [
        "Over 35 years of leadership and entrepreneurial experience",
        "Entrepreneur, board member and executive coach",
        "Experience in industry, trade, e-commerce and digitalisation",
        "Specialist in strategy, growth and transformation",
        "Sparring partner for owners, boards and management",
      ],
    },
    markipilot: {
      overline: "Digital growth",
      title: "marKIpilot — AI-powered app marketing",
      intro: "As founder of marKIpilot – Switzerland's leading AI-powered app-marketing platform – I combine artificial intelligence with data-driven performance marketing. An in-house MYSYMP product delivering measurable app growth.",
      services: [
        { t: "Pay-per-install", d: "You only pay for verified downloads – full cost transparency, zero risk." },
        { t: "22 AI agents", d: "Specialists for content, social, ASO, creative and UX – including a custom agent builder." },
        { t: "Performance media", d: "Campaign dominance across Apple Search Ads, Google, Meta and TikTok with AI optimisation." },
        { t: "Creative factory", d: "AI-generated creatives, playable ads and continuous A/B testing for maximum hook rate." },
        { t: "Tech & attribution", d: "Full-stack MMP integration (AppsFlyer/Adjust), SKAN 4.0 and deep-link architecture." },
        { t: "AI analytics tools", d: "Content scorer, Creative Analyzer (Vision AI) and AI visibility check for ChatGPT, Perplexity & Gemini." },
      ],
      stats: [
        { v: "22", l: "AI agents" },
      ],
      cta: "Discover marKIpilot",
      url: "https://markipilot.com",
    },
  },
  fr: {
    pills: ["Mandats d'administration", "Partenaire de réflexion", "Coach exécutif"],
    headline: "L'expérience qui fait avancer les entreprises.",
    intro: [
      "Les entreprises performantes ont besoin de plus que de bonnes idées. Elles ont besoin de personnes qui pensent de manière stratégique, identifient tôt les défis et accompagnent les décisions avec clairvoyance.",
      "C'est précisément là que j'interviens.",
      "Depuis plus de 35 ans, j'accompagne des entreprises en tant qu'entrepreneur, administrateur, directeur général et conseiller. Je connais la réalité des PME indépendantes tout comme les exigences des entreprises en croissance et des organisations en mutation.",
      "Ma force réside dans la capacité à saisir rapidement des situations complexes, à évaluer objectivement les opportunités et les risques et à développer, avec les responsables, des solutions viables – pragmatiques, indépendantes et avec un regard clair sur le succès durable de l'entreprise.",
    ],
    offerTitle: "Mon offre",
    offers: [
      {
        title: "Mandats d'administration",
        intro: "En tant qu'administrateur actif, j'accompagne les entreprises avec clairvoyance stratégique et expérience entrepreneuriale. Je soutiens en particulier dans les domaines suivants :",
        points: [
          "Stratégie d'entreprise et orientation future",
          "Digitalisation et développement de modèles d'affaires",
          "Croissance et mise à l'échelle de l'entreprise",
          "Processus de succession et de transmission",
          "Développement organisationnel",
          "E-commerce et modèles d'affaires numériques",
          "Stratégies de marketing et de vente",
          "Évaluation des risques et gouvernance",
          "Sparring pour propriétaires et direction",
        ],
        note: "Je ne conçois pas le conseil d'administration comme un simple organe de contrôle, mais comme un partenaire de réflexion actif doté d'une responsabilité entrepreneuriale.",
      },
      {
        title: "Coaching exécutif",
        intro: "Diriger aujourd'hui, c'est prendre chaque jour des décisions dans l'incertitude. En tant que coach personnel, j'accompagne les entrepreneurs, CEO, administrateurs et cadres sur des questions stratégiques et personnelles importantes. Les thèmes typiques sont :",
        points: [
          "Décisions stratégiques",
          "Développement de l'entreprise",
          "Leadership",
          "Bilan personnel",
          "Succession d'entreprise",
          "Processus de changement",
          "Gestion de crise",
          "Efficacité personnelle en tant que dirigeant",
        ],
        note: "Mon coaching n'est pas un programme standard. Il repose sur l'expérience, un dialogue honnête et l'objectif commun de développer des solutions durables.",
      },
    ],
    backgroundTitle: "Mon parcours",
    backgroundText: [
      "Ma carrière allie entrepreneuriat et responsabilité opérationnelle de direction. J'ai eu le privilège de créer et de développer des entreprises dans l'industrie, le commerce, l'e-commerce et la digitalisation. J'ai accompagné de nombreux projets de transformation, mis en œuvre des stratégies de croissance et conduit des entreprises à travers des processus de changement exigeants.",
      "Aujourd'hui, j'apporte cette expérience dans de nouveaux mandats en tant qu'administrateur, conseiller et coach.",
    ],
    approachTitle: "Ma méthode de travail",
    approachIntro: "Je travaille de manière indépendante, discrète et sur un pied d'égalité. Mes clients apprécient particulièrement :",
    approachPoints: [
      "une pensée entrepreneuriale plutôt que des concepts théoriques",
      "des évaluations objectives et honnêtes",
      "une analyse rapide de situations complexes",
      "des solutions pragmatiques et applicables",
      "une collaboration durable fondée sur la confiance",
    ],
    audienceTitle: "Pour qui je travaille",
    audienceIntro: "J'accompagne avant tout :",
    audience: [
      "PME",
      "Entreprises familiales",
      "Entrepreneurs",
      "Conseils d'administration",
      "Directions générales",
      "Entreprises en phase de croissance ou de changement",
      "Situations de succession et de transmission",
      "Start-ups aux ambitions de mise à l'échelle",
    ],
    ctaTitle: "Entrons en contact",
    ctaText: [
      "Que ce soit en tant qu'administrateur, partenaire de réflexion stratégique ou coach exécutif – je vous accompagne avec une expérience entrepreneuriale, une clairvoyance stratégique et l'objectif clair de développer durablement votre entreprise.",
      "Je me réjouis de faire votre connaissance et celle de votre entreprise.",
    ],
    profile: {
      role: "Entrepreneur · Administrateur · Coach exécutif",
      stats: [
        "Plus de 35 ans d'expérience de direction et d'entrepreneuriat",
        "Entrepreneur, administrateur et coach exécutif",
        "Expérience dans l'industrie, le commerce, l'e-commerce et la digitalisation",
        "Spécialiste de la stratégie, de la croissance et de la transformation",
        "Partenaire de réflexion pour propriétaires, administrateurs et directions",
      ],
    },
    markipilot: {
      overline: "Croissance numérique",
      title: "marKIpilot — marketing d'applications piloté par l'IA",
      intro: "En tant que fondateur de marKIpilot – la plateforme suisse de marketing d'applications pilotée par l'IA – j'associe l'intelligence artificielle à un marketing de performance axé sur les données. Un produit MYSYMP maison qui génère une croissance mesurable.",
      services: [
        { t: "Pay-per-install", d: "Vous ne payez que pour les téléchargements vérifiés – transparence totale, zéro risque." },
        { t: "22 agents IA", d: "Des spécialistes pour le contenu, le social, l'ASO, le créatif et l'UX – avec un constructeur d'agents personnalisés." },
        { t: "Médias de performance", d: "Domination des campagnes sur Apple Search Ads, Google, Meta et TikTok avec optimisation IA." },
        { t: "Creative Factory", d: "Créatifs générés par l'IA, playable ads et A/B testing continu pour un hook maximal." },
        { t: "Tech & attribution", d: "Intégration MMP full-stack (AppsFlyer/Adjust), SKAN 4.0 et architecture deep-link." },
        { t: "Outils d'analyse IA", d: "Content Scorer, Creative Analyzer (Vision AI) et vérification de visibilité IA pour ChatGPT, Perplexity et Gemini." },
      ],
      stats: [
        { v: "22", l: "agents IA" },
      ],
      cta: "Découvrir marKIpilot",
      url: "https://markipilot.com",
    },
  },
};
